import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { StaticImage } from 'gatsby-plugin-image'
import { useIntl } from 'react-intl'
import { useTheme } from 'styled-components'
import Typed from 'typed.js'

import { TitleM, TitleXS } from '../styles/Typography'
import { Container } from '../styles/PageLayout'
import { VoiceControlStyled } from '../styles/components/VoiceControlStyled'

/**
 * The voice control block.
 * @param {ComponentProps} props
 * @param {String} props.callName
 * @returns {FunctionComponent}
 */
const VoiceControl = ({ callName }) => {
  const intl = useIntl()
  const theme = useTheme()

  const text = useRef(null)
  const typed = useRef(null)

  const strings = [
    ' ',
    intl.formatMessage({ id: 'block_voice_control_text_1' }, { callName }),
    intl.formatMessage({ id: 'block_voice_control_text_2' }, { callName }),
    intl.formatMessage({ id: 'block_voice_control_text_3' }, { callName }),
  ]

  const options = {
    strings,
    typeSpeed: 75,
    backSpeed: 25,
    bindInputFocusEvents: true,
    backDelay: 1000,
    startDelay: 1000,
    loop: true,
    onStringTyped: (arrayPos) => {
      if (arrayPos === 1) {
        document.getElementsByClassName('img-all-on')[0].classList.add('visible')
        document.getElementsByClassName('img-tv-only')[0].classList.remove('visible')
        document.getElementsByClassName('img-dark')[0].classList.remove('visible')
      } else if (arrayPos === 2) {
        document.getElementsByClassName('img-all-on')[0].classList.remove('visible')
        document.getElementsByClassName('img-tv-only')[0].classList.add('visible')
        document.getElementsByClassName('img-dark')[0].classList.remove('visible')
      } else if (arrayPos === 3) {
        document.getElementsByClassName('img-all-on')[0].classList.remove('visible')
        document.getElementsByClassName('img-tv-only')[0].classList.remove('visible')
        document.getElementsByClassName('img-dark')[0].classList.add('visible')
      }
    },
  }

  useEffect(() => {
    typed.current = new Typed(text.current, options)

    return () => {
      typed.current.destroy()
    }
  }, [])

  return (
    <VoiceControlStyled $alignCenter>
      <Container $column $mobileColumn $alignItems="center">
        <TitleM className="title">{intl.formatMessage({ id: 'block_voice_control_title' })}</TitleM>
        <div className="content">
          <TitleXS $color={theme.textLight} $weight={400} className="text" ref={text} />
          <div className="img-container">
            <StaticImage
              className="img-dark"
              src="https://www.1home.io/xassets/voice-control-1.webp"
              alt={intl.formatMessage({ id: 'block_voice_control_alt' })}
              placeholder="none"
              quality="100"
            />
            <StaticImage
              className="img-all-on"
              src="https://www.1home.io/xassets/voice-control-2.webp"
              alt={intl.formatMessage({ id: 'block_voice_control_alt' })}
              placeholder="none"
              quality="100"
            />
            <StaticImage
              className="img-tv-only"
              src="https://www.1home.io/xassets/voice-control-3.webp"
              alt={intl.formatMessage({ id: 'block_voice_control_alt' })}
              placeholder="none"
              quality="100"
            />
          </div>
          <div className="overlay" />
        </div>
      </Container>
    </VoiceControlStyled>
  )
}

VoiceControl.propTypes = {
  callName: PropTypes.string.isRequired,
}

export default VoiceControl
